<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-3 detail_header">
          <PriceHeader title="รายการสินค้าที่ไม่ได้ตั้งราคา" :count="this.get_Product.length" type="รายการ"/>
          <div class="pa-3 text-right" v-if="$store.state.userDetail.manage_product_list === 1">
            <v-btn x-large @click="create_link" class="grad-success-bg white--text btn_mobile" style="font-size: 18px">เพิ่มข้อมูลสินค้า</v-btn>
          </div>
        </div>
        <div class="pa-4 pt-0">
          <div>
            <v-btn x-large class="grad-danger-bg white--text btn_mobile" @click="multi_delete" style="font-size: 18px"><v-icon>mdi-delete-empty-outline</v-icon> ลบสินค้าที่เลือก</v-btn>
          </div>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table v-model="selected" :headers="productHeaders" checkbox-color="#86bc3a" show-select item-key="id" :items="get_Product" :footer-props="footer_Props" :search="search" :items-per-page.sync="perPage" :page.sync="page" mobile-breakpoint="0">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td><v-checkbox color="#86bc3a" v-model="selected" :value="item"/></td>
                  <td>{{ item.product_code }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    <div v-if="item.name_sci !== null">{{ item.name_sci }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>{{ item.product_type_name }}</td>
                  <td><v-switch color="#86bc3a" @click="changeStatus(item.status, item.id)" v-model="item.status"></v-switch></td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDetails(item.id)" class="grad-success-bg white--text mr-1 mb-1" v-if="$store.state.userDetail.manage_product_list === 1" title="ดูรายละเอียด">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="getEdit(item.id)" class="grad-warning-bg white--text mr-1 mb-1" v-if="$store.state.userDetail.manage_product_edit === 1" title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
<!--                    <v-btn small height="42" @click="getDelete(item.id)" class="grad-danger-bg white&#45;&#45;text mb-1" v-if="$store.state.userDetail.manage_product_delete === 1" title="ลบ">-->
<!--                      <v-icon>mdi-delete-empty-outline</v-icon>-->
<!--                    </v-btn>-->
                  </td>
                  <td><v-btn small height="42" @click="getPrice(item.id)" class="grad-warning-bg white--text" style="font-size: 18px"><v-icon class="mr-1">mdi-cash-plus</v-icon> ตั้งราคา</v-btn></td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import PriceHeader from "./header_products/PriceHeader";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Product_NonPrice",
  components: {
    PriceHeader
  },
  data() {
    return {
      loading_page: false,
      search: null,
      alert_success: false,
      selected: [],
      page: this.$store.state.page_nonSet,
      perPage: this.$store.state.perPage,
      footer_Props: {
        showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        itemsPerPageOptions:[10, 50, 100, 200, 500, -1],
        'items-per-page-text':'รายการต่อหน้า'
      },
      productHeaders: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '125px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '300px',

        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'name_sci',
          fixed: true,
          width: '300px',
        },
        {
          text: 'ประเภท',
          value: 'product_type',
          fixed: true,
          width: '200px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '90px',
        },
        {
          text: 'จัดการสินค้า',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px',
        },
        {
          text: 'ตั้งราคา',
          value: '',
          sortable: false,
          fixed: true,
          width: '125px',
        },
      ],
      productList: [
        {
          id: 1,
          product_code: 'DS001S1',
          product_name: 'พารา',
          medic_name: 'พารา',
          type: 'ยาสามัญประจำบ้าน',
          status: true,
        },
        {
          id: 2,
          product_code: 'DS001S1',
          product_name: 'พารา',
          medic_name: 'พารา',
          type: 'ยาสามัญประจำบ้าน',
          status: true,
        },
        {
          id: 3,
          product_code: 'DS001S1',
          product_name: 'พารา',
          medic_name: 'พารา',
          type: 'ยาสามัญประจำบ้าน',
          status: false,
        },
        {
          id: 4,
          product_code: 'DS001S1',
          product_name: 'พารา',
          medic_name: 'พารา',
          type: 'ยาสามัญประจำบ้าน',
          status: true,
        },
      ],
      get_Product: [],
    }
  },
  methods: {
    checkLoading() {
      this.loading_page = true
      HTTP.post('/products/product/productsnotsetprice')
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.get_Product = res.data.object;
            }
          })
    },
    multi_delete() {
      let del_arr = this.selected.map(data => data.id)
      if(this.selected.length > 0) {
        Swal.fire({
          text: 'ต้องการดำเนินการต่อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((response) => {
          if (response.isConfirmed === true) {
            HTTP.post('/products/product/selectdelete', {
              id: del_arr
            }).then((res) => {
              if (res.data.success === true) {
                this.getProduct()
              }
            })
          }
        })
      } else {
        Swal.fire({
          text: 'กรุณาเลือกสินค้าที่ต้องการลบ !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getProduct() {
      this.loading_page = true
      HTTP.post('/products/product/productsnotsetprice')
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.get_Product = res.data.object;
            }
          })
    },
    changeStatus(status, product_id) {
      if (status == true) {
        status = 1;
      }
      else if (status == false) {
        status = 0;
      }
      HTTP.post('/products/product/changestatus', {
        status: status,
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true){
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 3000);
          this.getProduct();
        }
        else {
          Swal.fire({
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.getProduct();
          })
        }
      })
    },
    create_link() {
      this.$store.commit('link_temp', {
        link_url: 'stock/manage_product/productclose'
      })
      this.$router.push('/stock/manage_product/productadd')
    },
    getDetails(id) {
      this.$store.commit('link_temp', {
        link_url: 'stock/manage_product/productnonprice'
      })
      window.open('/stock/manage_product/productdetails/' + id, '_blank')
      // this.$router.push('/stock/manage_product/productdetails/' + id)
    },
    getEdit(id) {
      this.$store.commit('link_temp', {
        link_url: 'stock/manage_product/productnonprice'
      })
      window.open('/stock/manage_product/productedit/' + id, '_blank')
      // this.$router.push('/stock/manage_product/productedit/' + id)
    },
    getPrice(id) {
      this.$store.commit('link_temp', {
        link_url: 'stock/manage_product/productnonprice'
      })
      window.open('/stock/manage_product/productmakeprice/' + id, '_blank')
      // this.$router.push('/stock/manage_product/productmakeprice/' + id)
    },
    getDelete(id) {
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((response) => {
        if (response.isConfirmed === true) {
          HTTP.post('/products/product/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true){
              Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
              this.getProduct();
            }
          })
        }
      })
    }
  },
  beforeMount() {
    this.checkLoading();
  },
  watch:{
    page: function() {
      this.$store.commit('product_nonSet_temp', {
        page_nonSet: this.page
      })
    },
    perPage: function() {
      this.$store.commit('product_per_page_temp', {
        perPage: this.perPage
      })
    },
  },
}
</script>

<style scoped>
.detail_header {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 500px) {
  .detail_header {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
